const createHandleChange = (setFormData) => {
  return (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };
};
export {
  createHandleChange
};